"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.columnData = void 0;
exports.columnData = {
    location: {
        "id": "0",
        "label": "Locatie",
        "data": [
            {
                "name": "district",
                "label": "Gebied",
                "visible": true,
            },
            {
                "name": "neighbourhood",
                "label": "Wijk",
                "visible": true,
            },
            {
                "name": "location",
                "label": "Locatie",
                "visible": true,
            },
        ]
    },
    organisation: {
        "id": "1",
        "label": "Organisatie",
        "data": [
            {
                "name": "organisation",
                "label": "Organisatie",
                "visible": true,
            },
            {
                "name": "organisation_type",
                "label": "Soort organisatie",
                "visible": true,
            },
            {
                "name": "abandoned_date",
                "label": "Opgegeven op",
                "visible": true,
            },
            {
                "name": "contact_person",
                "label": "Contactpersoon",
                "visible": true,
            },
            {
                "name": "phone_number",
                "label": "Telefoonnummer",
                "visible": true,
            },
            {
                "name": "email",
                "label": "E-mailadres",
                "visible": true,
            },
            {
                "name": "website",
                "label": "Website",
                "visible": true,
            },
        ]
    },
    offers: {
        "id": "2",
        "label": "Aanbod",
        "data": [
            {
                "name": "activity",
                "label": "Activiteit",
                "visible": true,
            },
            {
                "name": "type",
                "label": "Soort",
                "visible": true,
            },
            {
                "name": "offer",
                "label": "Aanbod",
                "visible": true,
            },
        ],
    },
    moment: {
        "id": "3",
        "label": "Wanneer",
        "data": [
            {
                "name": "day",
                "label": "Weekdag",
                "visible": true,
            },
            {
                "name": "start_time",
                "label": "Begintijd",
                "visible": true,
            },
            {
                "name": "end_time",
                "label": "Eindtijd",
                "visible": true,
            },
        ],
    },
    audience: {
        "id": "4",
        "label": "Doelgroep",
        "data": [
            {
                "name": "sex",
                "label": "Geslacht",
                "visible": true,
            },
            {
                "name": "age",
                "label": "Leeftijd",
                "visible": true,
            },
            {
                "name": "target_audience",
                "label": "Levensfase",
                "visible": true,
                "width": "medium",
            },
            {
                "name": "movement_identity",
                "label": "Beweegidentiteit",
                "visible": true,
            },
            {
                "name": "health_impairment",
                "label": "Gezondheidsbeperkte",
                "visible": true,
            },
        ],
    },
    cost: {
        "id": "5",
        "label": "Meedoen",
        "data": [
            {
                "name": "admission_type",
                "label": "Deelname mogelijkheid",
                "visible": true,
            },
            {
                "name": "price_bracket",
                "label": "Kosten",
                "visible": true,
            },
            {
                "name": "price_structure",
                "label": "Kosten per",
                "visible": true,
                "size": "large",
            },
        ]
    },
    misc: {
        "id": "6",
        "label": "Overige",
        "data": [
            {
                "name": "youthfund_applicable",
                "label": "Jeugdfonds",
                "visible": true,
            },
            {
                "name": "inflow",
                "label": "Instroom mogelijk",
                "visible": true,
            },
            {
                "name": "remarks",
                "label": "Opmerking",
                "visible": true,
                "width": "large",
            },
        ]
    },
};
